import { useEffect, useState } from 'react'

/**
 * Resolves an image URL only when it can actually be loaded.
 *
 * Brand logo URLs are built from the subsidiary token without checking the CDN,
 * so hotels without an uploaded logo get a URL that responds with 403. Returning
 * an empty string in that case lets the editor fall back to its image placeholder.
 *
 * @param {string} imageUrl
 * @returns {Promise<string>} the URL when it loads, otherwise an empty string
 */
export function probeImageUrl(imageUrl) {
  const candidate = `${imageUrl || ''}`.trim()

  return new Promise(resolve => {
    if (!candidate) {
      resolve('')
      return
    }

    const probe = new Image()
    probe.onload = function () {
      resolve(candidate)
    }
    probe.onerror = function () {
      resolve('')
    }
    probe.src = candidate
  })
}

function useAvailableImageUrl(imageUrl) {
  const [availableUrl, setAvailableUrl] = useState('')

  useEffect(() => {
    let isActive = true

    probeImageUrl(imageUrl).then(resolvedUrl => {
      if (isActive) {
        setAvailableUrl(resolvedUrl)
      }
    })

    return function cleanup() {
      isActive = false
    }
  }, [imageUrl])

  return availableUrl
}

export default useAvailableImageUrl
